<template>
  <a-drawer
    :visible="visible"
    :title="'分配角色用户'"
    :width="1500"
    destroyOnClose
    @close="onClose"
  >
    <div class="distribution">
      <div class="action">
        <a-input-search
          placeholder="请输入姓名,账号来搜索"
          enter-button
          @search="onSearch"
        />
        <div class="line"></div>
        <a-button icon="plus" @click="addUser">加入用户</a-button>
        <a-button icon="delete" @click="deleteClick" type="danger" class="del"
          >删除</a-button
        >
      </div>
      <Table
        ref="userTable"
        :options="columns"
        :tableValue="dataList"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="initValue"
        :scroll="{ y: 1000 }"
        @selectRow="selectRow"
      ></Table>
    </div>
    <ChooseUser
      :visible="chooseUserVisible"
      @ok="chooseClose"
      :rows="rows"
      @updateList="initValue"
    ></ChooseUser>
  </a-drawer>
</template>

<script>
import { distributionColumns } from '../config'
import ChooseUser from './chooseUser.vue'
import Table from '@/views/Back/components/table/index.vue'
import { userList, delUserRole } from '@/api/role'
export default {
  props: {
    visible: Boolean,
    rows: Object
  },
  data () {
    return {
      searchValue: '',
      columns: distributionColumns,
      dataList: [],
      chooseUserVisible: false,
      slotOpt: [],
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      ids: []
    }
  },
  components: { ChooseUser, Table },
  watch: {
    rows (val) {
      if (val && this.visible) {
        this.$nextTick(() => {
          this.initValue()
        })
      }
    }
  },
  methods: {
    async initValue () {
      const params = {
        ...this.handlerBeforeRequestParams(),
        userName: this.searchValue,
        nickName: this.searchValue,
        roleId: this.rows.roleId
      }
      let res = await userList(params)
      this.dataList = res.rows
      this.dataList.forEach((item, key) => {
        item.key = key + 1
        item.name = item.userName
      })
    },
    // 请求前的参数收集
    handlerBeforeRequestParams () {
      const { pagination } = this.$refs.userTable
      const { pageSize, pageNum } = pagination
      const params = {
        pageNum,
        pageSize
      }
      return params
    },
    selectRow () {
      
      this.ids = this.$refs.userTable.selectedRowIds
    },
    onClose () {
      this.$emit('ok')
    },
    onSearch (val) {
      this.searchValue = val
      this.commonInit()
    },
    addUser () {
      this.chooseUserVisible = true
    },
    async deleteClick () {
      let res = await delUserRole(this.ids)
      if (res.code === 200) {
        this.$message.success('删除成功!')
        this.commonInit()
      } else {
        this.$message.warning(res.msg)
      }
      
    },
    chooseClose () {
      this.chooseUserVisible = false
    },
    commonInit () {
      this.$refs.userTable.pagination.pageNum = 1
      this.$refs.userTable.pagination.current = 1
      this.initValue()
    }
  }
}
</script>